import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { useAuth0 } from '@auth0/auth0-react'

import PortalArrowRightWhite from '../../../assets/images/OP_Portal_Arrow_White_RT.svg'
import { FormatAsMoney } from '../../../components/Fields/NumberFormatFields'
import HelloIntroBox from '../../../components/IntroBox'
import FurtherTrainingBorderBox from '../../../components/FurtherTrainingBorderBox/FurtherTrainingBorderBox'
import IpsaContext from '../../../context/IpsaContext'
import ActivityGauge from '../../../components/Charts/ActivityChart'

import styled from 'styled-components'

const GoalWrapper = styled.div`
    display: flex;
`

const GoalHeader = styled.h4`
    font-size: 20px;
`

const DashboardSidebar = () => {
    const { user } = useAuth0()
    // const [whatsNew, setWhatsNew] = useState({ fields: {} })

    const {
        insights: { currentYtdPremiums, currentProjectedYtdPremiums, ytdPremiumGoal },
    } = useContext(IpsaContext)

    return (
        <>
            <HelloIntroBox user={user} />
            <FurtherTrainingBorderBox />

            <ul id="ring-buttons">
                <li>
                    <Link to="/insights">
                        Insights <img src={PortalArrowRightWhite} alt="arrow" />
                    </Link>
                </li>
                <li>
                    <Link to="/training">
                        Training <img src={PortalArrowRightWhite} alt="arrow" />
                    </Link>
                </li>
                <li>
                    <Link to="/tools">
                        Tools <img src={PortalArrowRightWhite} alt="arrow" />
                    </Link>
                </li>
                <li>
                    <Link to="/clients">
                        IPSA <img src={PortalArrowRightWhite} alt="arrow" />
                    </Link>
                </li>
            </ul>

            {/* {whatsNew && slug && (
                <div className="border-box">
                    <h2>What's new?</h2>
                    <p>{summaryText}</p>
                    <Link to={`/whatsnew/${slug}`} className="more-link">
                        Learn More
                    </Link>
                </div>
            )} */}

            <div className="border-box" style={{ marginTop: '30px' }}>
                <ActivityGauge
                    title="Your Goal Metric"
                    current={currentYtdPremiums}
                    projected={currentProjectedYtdPremiums}
                    goal={ytdPremiumGoal}
                    backgroundColor="none"
                />

                <GoalWrapper>
                    <div>
                        <GoalHeader>Premium Goal</GoalHeader>
                        <p>{FormatAsMoney(ytdPremiumGoal)}</p>
                    </div>
                    <div style={{ paddingLeft: '10%' }}>
                        <GoalHeader>Premium YTD</GoalHeader>
                        <p>{FormatAsMoney(currentYtdPremiums)}</p>
                    </div>
                </GoalWrapper>
                <Link to={'/insights'} className="more-link">
                    Insights
                </Link>
            </div>
        </>
    )
}

export default DashboardSidebar
